import { render } from "./rateSettings.vue?vue&type=template&id=7020d1f8&scoped=true"
import script from "./rateSettings.vue?vue&type=script&lang=js"
export * from "./rateSettings.vue?vue&type=script&lang=js"

import "./rateSettings.vue?vue&type=style&index=0&id=7020d1f8&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7020d1f8"]])

export default __exports__